<app-modal>
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title">{{ title }}</h5>

    </div>
    <div class="modal-body" modal-body>
        <div class="search-actions">
            <app-search-bar
                (search)="onSearch($event)"
                [responsive]="true">
            </app-search-bar>

            <app-button type="simple"
                        (click)="toggleSelectAll()">
                {{ areAllSelected ? ('generic.buttons.deselectAll' | translate) : ('generic.buttons.selectAll' | translate) }}
            </app-button>
        </div>

        <app-task *ngFor="let task of filteredTasks"
                  [task]="task"
                  [highlighted]="isSelected(task)"
                  (toggleHighlight)="handleSelectTask($event)">
        </app-task>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="simple"
                    (click)="onCancel()"
                    data-dismiss="modal">{{ "generic.buttons.close" | translate }}
        </app-button>
        <app-button type="primary"
                    (click)="onSave()"
                    data-dismiss="modal">{{ "generic.buttons.save" | translate }}
        </app-button>
    </div>
</app-modal>
